import Services from '../../services/Services';

export async function getPropertyTypeList(data) {
    let message;
    const res = await Services.api(`properties/types/list`, data, 'post');

    if (res.status === 200) {
        message = res.data;
    } else {
        message = res.message;
    }

    return {
        "status": res.status,
        "message": message
    }
};